import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useEditLetterStatusModal } from '../context/EditLetterStatusModalContext';

const EditLetterStatusModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useEditLetterStatusModal();

  const buttonDisabled = !data.invitationStatus || !data.assumeCheckboxChecked;

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveStatus}
          disabled={buttonDisabled}
        >
          {t('Save')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default EditLetterStatusModalFooter;
